import script from "./order-history.vue?vue&type=script&setup=true&lang=js"
export * from "./order-history.vue?vue&type=script&setup=true&lang=js"

import "./order-history.vue?vue&type=style&index=0&id=4f52c87c&lang=css"

const __exports__ = script;

export default __exports__